import getConfigByName from "./index";

const config = getConfigByName();

export const VERIFICATION_API = `${config?.backendURL}api/ms/verification`;

/**
 * Base for the liveness routes.
 *
 * When a brand sets `verificationDirectURL`, liveness calls bypass the AP backend
 * and hit the verification microservice directly — the AP proxy has not deployed
 * these routes yet and answers `{"errObj":{"upstreamStatus":403}}`.
 *
 * The direct base already includes `/api`, whereas the proxied base does not, so
 * callers must NOT prefix `/api` themselves. Remove `verificationDirectURL` from
 * a brand's config to move it back onto the proxy — nothing else changes.
 */
export const LIVENESS_API = config?.verificationDirectURL || `${VERIFICATION_API}/api`;
export const QUESTIONNAIRE_API = `${config?.backendURL}api/ms/questionnaire`;
export const COMMISSION_API = `${config?.backendURL}api/ms/commission`;
export const CASE_MANAGEMENT_API = `${config?.backendURL}api/ms/case-management`;
